import { render, staticRenderFns } from "./LocationSalesTable.vue?vue&type=template&id=19b2729a&scoped=true&"
import script from "./LocationSalesTable.vue?vue&type=script&lang=ts&"
export * from "./LocationSalesTable.vue?vue&type=script&lang=ts&"
import style0 from "./LocationSalesTable.vue?vue&type=style&index=0&id=19b2729a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2729a",
  null
  
)

export default component.exports